import { useState } from "react";
import { Header } from "../../../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../../../components/Landing/Header/headerScc";
import { BreadCrumb } from "../../../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Footer } from "../../../../../components/Landing/Footer";
import { Table, Button, Modal, Radio } from "antd";
import { ReactComponent as EyeIcon } from "../../../../../assets/eye-detail.svg";
import ArtistasCallejeros from "../../../../../assets/artistaCallejero.jpg"
import FeriaFlores from "../../../../../assets/FeriaFlores.jpg"
import bannerArtistasCallejeros from "../../../../../assets/bannerArtistasCallejeros.jpg"
import bannerFeriaFlores from "../../../../../assets/bannerFeriaFlores.jpg"
import bannerBandasMarcha from "../../../../../assets/Banner concurso de bandas_Mesa.png"
import lineamientoBandasMarcha from "../../../../../assets/Concurso Internacional de Bandas MMM_Lineamientos 2025.pdf"
import { FaInfoCircle, FaWpforms } from "react-icons/fa"
import bannerMuseos from "../../../../../assets/bannerformulariomuseos.png"
import cartaConformacion from "../../../../../assets/formato/CartadeConformaciondeGrupo_2025.docx"
import propuestaTecnicaMuseos from "../../../../../assets/formato/Formato-Propuesta-Invitacion-Museos-2025.docx"
import presupuestoMuseos from "../../../../../assets/formato/Formato-Presupuesto-Inivtacion-Museos-2025.xlsx"
import DeclaracionMuseos from "../../../../../assets/formato/Declaracion-juramentada-nivel-desempeÃ±o-museal-2025.docx"
import lineamientoMMM from "../../../../../assets/formato/Invitacion_Beneficios_Museos_Publicable.pdf"
//Feria
import propuestaTecnicaFeria from "../../../../../assets/formato/FormatoPropuestaTecnica_invitacionpublica.docx"
import presupuestoFeria from "../../../../../assets/formato/FormatoPresupuesto_invitacionpublica.xlsx"
import DeclaracionMuseosGrupos from "../../../../../assets/formato/DeclaraciondeResidenciaGruposConformados2025_invitacionpublica.docx"
import trayectoriaFeria from "../../../../../assets/formato/Formato_Trayectoria_invitacionpublica.docx"
import relacionFeria from "../../../../../assets/formato/RelaciondeParticipantes_invitacionpublica.docx"
import lineamientoFeria from "../../../../../assets/formato/Invitación_Desfile_de_Comparsas_Avenida_Primavera_y_Desfile_de_Silleteros.pdf"
//Feria

interface Formato {
  nombre: string;
  url: string;
}

export const Form = () => {

  const [visualizasdocument, setVisualizarDocument] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');
  const [banner, setBanner] = useState<string>('');
  const [evento, setEvento] = useState<string>('');
  const [boton, setBoton] = useState<string>('');
  const [lineamiento, setLineamiento] = useState<string>('');
  const [formatos, setFormatos] = useState<Formato[]>([]);
  const [pj, setPj] = useState<Formato[]>([]);
  const [gc, setGC] = useState<Formato[]>([]);

  const abrirForm = (item) => {
    setUrl(item.url)
    setBanner(item.banner)
    setEvento(item.evento)
    setBoton(item.boton)
    setLineamiento(item.lineamiento)
    setFormatos(item.formatos)
    setPj(item.pj)
    setGC(item.gc)
    setVisualizarDocument(true);
  }

  const onCancel = () => {
    setVisualizarDocument(false);
    setUrl('')
  }

  const event = [
    {
      url: "https://docs.google.com/forms/d/e/1FAIpQLSfTzX6RyGZrcmIMBhW8Lj1RG5BroTEAcCGQSpL4ukSkNP94IA/viewform?embedded=true",
      banner: bannerMuseos,
      boton: bannerMuseos,
      evento: "Invitación Museos 2025",
      lineamiento: lineamientoMMM,
      formatos: [
        {
          nombre: "Formato de propuesta técnica",
          url: propuestaTecnicaMuseos
        },
        {
          nombre: "Formato de presupuesto",
          url: presupuestoMuseos
        },
        {
          nombre: "Formato de declaración juramentada",
          url: DeclaracionMuseos
        }
      ],
      gc: [],
      pj: []
    },
    {
    url: '',
    gc: [
      {
        nombre: "Grupo Conformado",
        url: 'https://docs.google.com/forms/d/e/1FAIpQLSf8w4qbs7TxnXiImTCgbSCCEdMUJ2k85l1FDsPGip07NN3X5Q/viewform?embedded=true'
      }
    ],
    pj: [
      {
        nombre: "Persona Jurídica",
        url: 'https://docs.google.com/forms/d/e/1FAIpQLSe07xFvGAKH8LF7ic-K4w5Zihs8eUvkKJWafmcsyq3qyEheqA/viewform?embedded=true'
      },
    ],
    banner: bannerFeriaFlores,
    boton: FeriaFlores,
    evento: "Feria de las Flores 2025",
    lineamiento: lineamientoFeria,
    formatos: [
      {
        nombre: "Formato de propuesta técnica",
        url: propuestaTecnicaFeria
      },
      {
        nombre: "Formato de presupuesto",
        url: presupuestoFeria
      },
      {
        nombre: "Formato declaración de residencia grupos conformados",
        url: DeclaracionMuseosGrupos
      },
      {
        nombre: "Formato de trayectoria",
        url: trayectoriaFeria
      },
      {
        nombre: "Formato de relación de participantes",
        url: relacionFeria
      }
    ],
  },
  {
    url: "https://docs.google.com/forms/d/e/1FAIpQLSeoxSWcCmTMOmck3hJaIL5zj5E4ZxoPwyrIVVzsoIXj2461lg/viewform?embedded=true",
    banner: bannerBandasMarcha,
    boton: bannerBandasMarcha,
    evento: "11 Concurso Internacional de Bandas 2025",
    lineamiento: lineamientoBandasMarcha,
    formatos: [
      {
        nombre: "Carta de conformación",
        url: cartaConformacion
      }
    ],
    gc: [],
    pj: []
  },
  {
    url: "https://docs.google.com/forms/d/e/1FAIpQLScAh4SdH0L-qEoRI0Hsv3K3VH-OfpK9w_vxfmj4GThUAj8Ebg/viewform?embedded=true",
    banner: bannerArtistasCallejeros,
    boton: ArtistasCallejeros,
    evento: "Artistas Callejeros 2025",
    gc: [],
    pj: []
  }
];

const [tipoFormulario, setTipoFormulario] = useState(null);

const handleTipoChange = e => {
  setTipoFormulario(e.target.value);
};


  return (
    <>
      <Header />
      <HeaderScc />
      <div className="">
        <div className="row">
          <br />
        </div>
        <div className="justify-content-center">
          <div className="container-titles-information-component">
            <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
              Formularios de
              <span className="font-family-Montserrat-Bold"> Inscripciones</span>
            </div>
          </div>
        </div>
        <div className="container-fluid2 pt-5">
          <div className="row justify-content-center">
            {event.map((item, index) => (
              <div className="col-md-6 col-sm-12" key={index}>
                <br />
                <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                  <img
                    src={item.boton}
                    alt={`Evento ${index}`}
                    className="card4"
                    style={{ cursor: "pointer" }}
                    onClick={() => abrirForm(item)}
                  />
                </div>
                <br />
              </div>
            ))}
          </div>
        </div>
        <div className="row">
          <br />
          <br />
        </div>
      </div>
        <Modal
          className="ant-modal-close-x2"
          maskStyle={{
            backgroundColor: "rgba(6, 100, 144 ,0.71)",
          }}
          visible={visualizasdocument}
          onCancel={onCancel}
          width={1200}
          footer={[
            <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
              Cerrar
            </Button>,
          ]}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <div>
            <img
              src={banner}
              alt={`Evento ${evento}`}
              className="card4"
              style={{ cursor: "pointer" }}
            />
            <br />
            <br />
            {lineamiento ? (
              <div className="font-size-26px font-family-Montserrat text-center font-color-black">
                <a target="_blank" href={lineamiento}><FaInfoCircle /> Lineamiento y condiciones de participación</a>
                <br />
              </div>
              ) : ''
            }
            {
              <div>
                {formatos?.length > 0 && formatos.map((formato, index) => (
                  <div
                    key={index}
                    className="font-size-26px font-family-Montserrat text-center font-color-black"
                  >
                    <a className="font-color-black" target="_blank" href={formato.url} rel="noopener noreferrer">
                      <FaWpforms /> {formato.nombre}
                    </a>
                    <br />
                  </div>
                ))}
              </div>
            }
            <br />
            {url ? (
              <iframe
                src={url}
                title="Formulario"
                style={{ width: '100%', height: '500px' }}
              />
            ) : (
              ''
            )}
            {
               <div className="container">
                {evento === 'Feria de las Flores 2025' && (
                  <div>
                    <div className="font-size-16px font-family-Montserrat text-center font-color-black">
                        Por favor, elija un formulario de registro.
                    </div>
                    <div className="text-center my-4">
                      <Radio.Group onChange={handleTipoChange} value={tipoFormulario}>
                        <Radio value="GC">
                          <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                              Grupo Conformado (GC)
                          </div>
                        </Radio>
                        <Radio value="PJ">
                          <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                              Persona Jurídica (PJ)
                          </div>
                        </Radio>
                      </Radio.Group>
                    </div>
                  </div>
                  )}
                  <div className="row">
                    {tipoFormulario === 'GC' && (
                      <div className="col-12 text-center">
                        {gc.map((item, index) => (
                          <div key={index} className="mb-4">
                            <iframe
                              src={item.url}
                              title={`Formulario GC ${index}`}
                              style={{ width: '100%', height: '500px' }}
                            />
                          </div>
                        ))}
                      </div>
                    )}

                    {tipoFormulario === 'PJ' && (
                      <div className="col-12 text-center">
                        {pj.map((item, index) => (
                          <div key={index} className="mb-4">
                            <iframe
                              src={item.url}
                              title={`Formulario PJ ${index}`}
                              style={{ width: '100%', height: '500px' }}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
            }
          </div>
        </Modal>
      <Footer />
    </>
  );
};
